import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import ContentCard from "../comps/ContentCard/ContentCard";
import Sidebar from "../comps/Sidebar/Sidebar";

export default function Collaboration() {
  const menu = [
    {
      name: "Overview",
      id: "Collaboration-0",
    },
    {
      name: "With Rjmart",
      id: "Collaboration-1",
    },
    {
      name: "The 7th Southern China Regional Meeting",
      id: "Collaboration-2",
    },
    {
      name: "Modeling & Software Symposium",
      id: "Collaboration-3",
    },
    {
      name: "The 10th CCiC",
      id: "Collaboration-4",
    },
    {
      name: "With iGEM CPU_CHINA",
      id: "Collaboration-5",
    },
    {
      name: "2023 SynBio Plus AI webinar",
      id: "Collaboration-6",
    },
    {
      name: "With CNGB",
      id: "Collaboration-7",
    },
    {
      name: "With iGEM WHU-CHINA",
      id: "Collaboration-8",
    },
  ];
  return (
    <div className="general-background">
      <NavigationBar />
      <Sidebar menu={menu} />
      <div className="main-container">
        <p className="title">Collaboration:</p>
        <p className="subtitle" key={"Collaboration-0"} id="Collaboration-0">
          • Overview
        </p>
        <ContentCard
          content={` 
            <p>
            We believe that collaboration is necessary for the project’s progress and perfection, so we have attempted to communicate with other teams or companies in relevant fields  as widely as possible, and had in-depth collaborations with them. It turns out that each collaboration is illuminating and helpful. We have gained a lot of suggestions or ideas and improved our project accordingly.
            </p>
              `}
        />
        <p className="subtitle" key={"Collaboration-1"} id="Collaboration-1">
          • With Rjmart
        </p>
        <ContentCard
          content={` 
            <p>
            In the early stages, we visited Rjmart with the intent of exploring potential collaborations. Rjmart stands out as a "specialized, refined, distinctive, and innovative" enterprise located in Guangdong Province. They have pioneered the development of a procurement management platform catering to the needs of the scientific research industry, known as the Ruijing Procurement Platform. At present, this platform has ascended to become the largest of its kind in the country, encompassing participation from over 16,000 scientific research industry suppliers from across the nation. The Ruijing Procurement Platform proudly hosts a diverse inventory of more than 80 million distinct products. Notably, in the year 2021, Rjmart was honored by its inclusion among China's Top 100 Future Healthcare Enterprises.
            We were pleasantly greeted by the staff during our visit, and we noticed that they were working on creating a biomedical research Illustration website, in order to address limitations such as scarce resources, exorbitant costs, inadequate canvas dimensions, and challenges in image composition. We suggested that they expand the resource repository, and enhance the scientific rigor and precision of images. What’s more, our discussions encompassed topics ranging from the iGEM competition to underlying issues related to website design.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p1.jpg'
            alt='Figure 1. Visit to Rjmart in April'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 1. Visit to Rjmart in April
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p2.jpg'
            alt='Figure 2. Visit to Rjmart in July'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 2. Visit to Rjmart in July
            </p>
            <br/>
            <p>
            On July 28th, we once again visited Rjmart. During our visit, we engaged in discussions regarding both our biorocket project and website design with their staff. In terms of algorithms, we introduced the concept of machine learning algorithms, placing emphasis on their advantages, which encompass scalability, efficiency, and continuous improvement. They provided us with valuable advice, recommending that we explore additional papers related to artificial intelligence, particularly those concerning convolutional neural networks and generative adversarial networks.
            </p>
            <br/>
            <p>
            Significantly, they encouraged us to actively pursue multitasking collaboration to prevent any potential delays in progress. Furthermore, they reminded us of the importance of expanding our team by recruiting additional members to contribute to tasks involving graphic design, element design, and visual communication. Following their guidance, we successfully attracted a few talented artists who enthusiastically joined our team, significantly enhancing our collective strength.
            </p>
              `}
        />
        <p className="subtitle" key={"Collaboration-2"} id="Collaboration-2">
          • The 7<sup>th</sup> Southern China Regional Meeting
        </p>
        <ContentCard
          content={` 
            <p>
            On May 21, the 7th iGEM South China Networking Conference was successfully held at Shenzhen University. This year, a total of 16 teams from colleges and high schools in South China came to the activity site to learn and exchange. With the theme of "Villagarnival (villages-carnival)", this exchange meeting in South China divided the 16 teams into four villages, namely, "Therapy", "Testing", "Agriculture", and "Manufacturing", according to the theme of the project, and formed a favorable atmosphere for cooperation and exploration within the cluster and learning from each other among the clusters. Songlin Shi and Xiaoxi Du, two patient and professional seniors, have given detailed introductions and suggestions. Shi’s “3R” principle (Reflective, Responsible, Responsive) inspired us greatly.
            </p>
            <br/>
            <p>
            We also introduced our project in this meeting, and communicated with other iGEM teams, from which we gained a lot. Because of the relevance of the selected topic, we had more detailed and deeper discussion with SUSTech-Shenzhen (from Southern University of Science and Technology), who focused on T6SS (type vi secretion system), and found answers here for some questions about our projects.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p3.jpg'
            alt='Figure 3. The 7th iGEM South China Networking Conference'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 3. The 7th iGEM South China Networking Conference
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p4.jpg'
            alt='Figure 4. Communicate with SUSTech-Shenzhen'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 4. Communicate with SUSTech-Shenzhen
            </p>
              `}
        />
        <p className="subtitle" key={"Collaboration-3"} id="Collaboration-3">
          • Modeling & Software Symposium
        </p>
        <ContentCard
          content={` 
            <p>
            On May 28th, we were invited to participate in the CCiC online symposium focusing on modeling and software. Jiayuan Tian, representing our team, had a presentation on the importance of modeling and software in synthetic biology research. During his presentation, Jiayuan Tian emphasized the role of modeling in predicting and simulating biological systems. He discussed how models can provide valuable insights into the behavior of biological components and help optimize the design of synthetic biological systems.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p5.jpg'
            alt='Figure 5. Modeling & Software symposium poster'
            class='content-figure'
            style='width:18%'
            />
            </div>
            <p class='content-legend'>
            Figure 5. Modeling & Software symposium poster
            </p>
              `}
        />
        <p className="subtitle" key={"Collaboration-4"} id="Collaboration-4">
          • The 10th Conference of China iGEMer Community (CCiC)
        </p>
        <ContentCard
          content={` 
            <p>
            The 10th China Regional iGEMer Communication Conference (CCiC) was successfully held from July 8 to July 10, 2023 in Haikou, Hainan Province. The conference was held online and offline simultaneously, attracting more than 1,000 synthetic biology enthusiasts to participate, and it was also the first time that CCiC resumed offline after the liberalization of the epidemic policy. The theme of this year's CCiC is "Exploring the Potential of Synthetic Biology", which aims to encourage everyone to think about and explore the role of synthetic biology in the future development of society.
            </p>
            <br/>
            <p>
            Siying Wang presented our project “BioRocket” online, which was met with enthusiasm from the iGEM participants. In the Q&A session, participants questioned about the project's scalability, potential challenges, and future plans. Siying Wang provided detailed and insightful answers, addressing concerns and sharing the team's vision for further development.
            </p>
            <br/>
            <p>
            CCiC provided a platform for iGEM teams and young synthetic biology enthusiasts in China to share resources and promote mutual learning and exchange. We not only received feedback from experts to optimize our work, but also made friends with many teams from China there.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p6.jpg'
            alt='Figure 6. Online meeting of the 10th CCiC'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 6. Online meeting of the 10<sup>th</sup> CCiC
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p7.jpg'
            alt='Figure 7. Online meeting of the 10th CCiC'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 7. Online meeting of the 10<sup>th</sup> CCiC
            </p>
              `}
        />
        <p className="subtitle" key={"Collaboration-5"} id="Collaboration-5">
          • With iGEM CPU_CHINA
        </p>
        <ContentCard
          content={` 
            <p>
            This summer, we went to the National Institute of Biological Sciences, Beijing together with iGEM CPU_CHINA and shared each other's projects during the exchange. They shared with us the current status of drug delivery platform development from the perspective of pharmacy students, and gave us suggestions on our projects based on the drug development process and safety.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p8.jpg'
            alt='Figure 8. With iGEM CPU_CHINA'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 8. With iGEM CPU_CHINA
            </p>
              `}
        />
        <p className="subtitle" key={"Collaboration-6"} id="Collaboration-6">
          • 2023 SynBio Plus AI webinar
        </p>
        <ContentCard
          content={` 
            <p>
            To explore the copyright issues raised by AI and the question of whether algorithms need to be all open source, we hosted a webinar. And we invited 7 iGEM teams to participate and had in-depth communication with them.
            </p>
            <br/>
            <p>
            On the webinar, we shared our opinions on AI technology’s application, limitations, regulation and promotion. We think that AI has the potential for a wide range of applications in synthetic biology, but it also needs to be properly regulated and promoted in terms of ethics, regulations, and safety to ensure its safety and sustainability. The other teams also shared their views in turn, which prompted us to think further. We also took inspiration from their sharing to further reflect on the contribution of our project and approaches of human practices.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p9.jpg'
            alt='Figure 9. 2023 SynBio Plus AI webinar poster'
            class='content-figure'
            style='width:22%'
            />
            </div>
            <p class='content-legend'>
            Figure 9. 2023 SynBio Plus AI webinar poster
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-p10.png'
            alt='Figure 10. 2023 SynBio Plus AI webinar'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 10. 2023 SynBio Plus AI webinar
            </p>
              `}
        />
        <p className="subtitle" key={"Collaboration-7"} id="Collaboration-7">
          • With China National GeneBank (CNGB)
        </p>
        <ContentCard
          content={` 
            <p>
            On August 21st, we visited the China National GeneBank (CNGB) in Shenzhen and engaged in a fruitful conversation with Dr. Yun Wang. Dr. Wang, an Associate Researcher in Bioinformatics specializing in Synthetic Biology at the BGI Research Institute, provided us with valuable insights and guidance. Our visit to CNGB was an eye-opening experience as we explored the rich history and remarkable achievements of BGI. Dr. Yun Wang then proceeded to elaborate on the impressive strides made in synthetic biology. This encompassed synthetic genomes, biological chassis, DNA digital information storage, and phage modification. Of particular interest to us was the development of phage tools and technologies. This interest stemmed from our research on the extracellular contractile injection systems (eCISs), which bears structural similarities to phages and shares functionality with phages. Dr. Yun Wang emphasized that extensive genotype and phenotype datasets are instrumental in advancing research on phage-host interactions. Moreover，hunter series tools are developed for mining information and functional genetic parts that have application potential.
            </p>
            <br/>
            <p>
            During our visit, we introduced our project, BioRocket, to Dr. Yun Wang and his colleagues. Their valuable advice influenced our project's approach and development trajectory. We received encouragement to address specific challenges by considering real-world applications and harnessing our project's unique strengths. In the realm of models and algorithms, we were advised to seek optimal solutions while ensuring a well-balanced dataset and efficient workload management. Data support emerged as a critical factor in our project, necessitating a meticulous alignment of our design choices with the available data. Our discussions also delved into strategies for maximizing the potential of additional data through focused data mining and the expansion of our usable eCIS dataset. Upon project completion, we planned to compare our eCIS dataset with existing ones to showcase the extent of expansion and its value. Dr. Yun Wang expressed hope that our project and dataset would be widely utilized by researchers to explore protein delivery systems.
            </p>
            <br/>
            <p>
            In line with the growing community of researchers in this field, we have embarked on the development of alternative systems and methods for advancing delivery systems. This endeavor places significant emphasis on both quantity and accuracy in deriving insights from this extensive dataset. Furthermore, we hold aspirations of deepening our commercial collaboration with BGI. Leveraging their AI and synthetic biology platform, we aim to drive our project forward, fostering mutual success in our endeavors.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-figure11.png'
            alt='Figure 11. Visit China National GeneBank (CNGB)'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 11. Visit China National GeneBank (CNGB)
            </p>
              `}
        />
        <p className="subtitle" key={"Collaboration-8"} id="Collaboration-8">
          • With iGEM WHU-CHINA
        </p>
        <ContentCard
          content={` 
            <p>
            In the early autumn of this year, we met with iGEM WHU-CHINA at Wuhan University to share our projects. Their project uses CRISPR-Cas9 technology to make mutations at the molecular level, enabling the recording module to function. They enlightened us on the conditions for controlling wet experiments, and advised us on the aspects of data mining and storage and information security for our project.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-figure12.jpg'
            alt='Figure 12. With iGEM WHU-CHINA'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 12. With iGEM WHU-CHINA
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/collaboration-figure13.jpg'
            alt='Figure 13. With iGEM WHU-CHINA'
            class='content-figure'
            style='width:42%'
            />
            </div>
            <p class='content-legend'>
            Figure 13. With iGEM WHU-CHINA
            </p>
              `}
        />
      </div>
      <Footer />
    </div>
  );
}
